import { PropTypes } from '@material-ui/core';
import { Theme, makeStyles } from '@material-ui/core/styles';

//Annoyingly as we also have a bootstrap dependency we also get _reboot which messes with some of the styles
const getColor = (theme: Theme, propColor?: PropTypes.Color) => {
  switch (propColor) {
    case 'inherit':
      return 'inherit';
    case 'primary':
      return theme.palette.primary.contrastText;
    case 'secondary':
      return theme.palette.secondary.contrastText;
    default:
      return 'default';
  }
};

interface StylesPropType {
  color?: PropTypes.Color;
}

export const useStyles = makeStyles<Theme, StylesPropType>((theme: Theme) => {
  return {
    link: {
      '&:hover': {
        color: (props: StylesPropType) => getColor(theme, props.color),
      },
    },
    button: {
      color: '#3463FD',
      borderColor: '#3463FD',
      background: 'white',
      border: '1.5px solid',
      margin: theme.spacing(1),
      fontWeight: 'bold',
      textTransform: 'none',
      '&:hover': {
        color: '#FFFFFF',
        background: '#3463FD',
      },
      '&:focus': {
        outline: 'none',
      },
    },
  };
});
